import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from '../shared/config/config';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    private config: Config | undefined;
    private http = inject(HttpClient);

    constructor() { }

    /**
     * Loads the configuration.
     * This is where you would typically fetch a config.json file from assets if needed.
     */
    loadConfig(url: string): Promise<void> {
        return new Promise((resolve) => {
            this.http.get<Config>(url).subscribe({
                next: (config) => {
                    this.config = config;
                    resolve();
                },
                error: (err) => {
                    console.error('ConfigService: Failed to load config from ' + url, err);
                    resolve(); // Resolve anyway to allow the app to bootstrap
                }
            });
        });
    }

    get settings(): Config {
        return this.config || { END_POINT: '', CLIENT_ID: '' };
    }

    get(): Config {
        return this.config || { END_POINT: '', CLIENT_ID: '' };
    }
}
